<template>
    <div id="ag-grid-demo">
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Add Wave Pick</h4>
                </div>
                <div class="flex items-center">
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="filter_list"
                        @click="filter.active = true"
                    >Filter</vs-button>
                    <vs-button
                        @click="createPickInit"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="add"
                        :disabled="pickData.length < 1"
                    >Create Wave Pick</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="deliveryOrders"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="multiple"
                @selectionChanged="addPickData"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
            <vs-prompt @accept="filterData" title="Filter" :active.sync="filter.active">
                <div class="con-exemple-prompt">
                    <vs-input
                        placeholder="Reference"
                        v-model="filter.reference"
                        class="mt-4 mb-2 w-full"
                    />
                    <vs-select class="selectExample" v-model="filter.type" width="100%">
                        <vs-select-item value="single" text="Single" />
                        <vs-select-item value="multiple" text="Multiple" />
                    </vs-select>
                </div>
            </vs-prompt>
            <vs-popup
                :title="`Summary (` + pickData.length + ` outbound selected)`"
                :active.sync="showPickedData"
            >
                <vs-table :data="pickData">
                    <template slot="thead">
                        <vs-th>No.</vs-th>
                        <vs-th>Reference</vs-th>
                        <vs-th>Warehouse</vs-th>
                        <vs-th>Product Code</vs-th>
                        <vs-th>Qty</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].index">{{ data[indextr].index }}</vs-td>
                            <vs-td>{{ data[indextr].reference }}</vs-td>
                            <vs-td>{{ data[indextr].warehouse.warehouses_code }}</vs-td>
                            <vs-td>{{ data[indextr].product.product_code }}</vs-td>
                            <vs-td>{{ data[indextr].base_qty + ' ' +data[indextr].base_uom.uom.name }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                <div class="flex flex-wrap items-center justify-between mt-5">
                    <div class="flex items-center"></div>
                    <div class="flex items-center">
                        <vs-button
                            class="mb-4 md:mb-0"
                            icon="add"
                            @click="createPick"
                            color="success"
                            :disabled="pickData.length < 1"
                        >Create Wave Pick</vs-button>
                    </div>
                </div>
            </vs-popup>
        </vx-card>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            deliveryOrders: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            maxRetry: 10,
            clientOptions: [],
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            filter: {
                type: "single",
                reference: "",
                active: false,
                client: "",
                client_id: null
            },
            pickData: [],
            pickMode: false,
            showPickedData: false
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("email", null);
            } else this.gridOptions.columnApi.setColumnPinned("email", "left");
        },

        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        refreshData() {
            this.maxRetry = 10;
            this.fetchData();
        },
        fetchData() {
            this.isLoading = true;
            this.maxRetry = this.maxRetry - 1;
            Promise.all([
                this.$http.post(
                    "outbound/wave_pick?page=" + this.currentPage,
                    this.filter
                )
            ])
                .then(
                    this.$http.spread(resp => {
                        this.deliveryOrders = resp.data.data;
                        this.totalPage = resp.data.last_page;
                        this.currentPage = this.currentPage;
                        this.dataTotal = resp.data.total;
                        this.dataFrom = resp.data.from ? resp.data.from : 0;
                        this.dataTo = resp.data.to ? resp.data.to : 0;
                        this.isLoading = false;
                    })
                )
                .catch(() => {
                    if (this.maxRetry == 0) {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.refreshData();
                            },
                            acceptText: "Yes",
                            cancelText: "No"
                        });
                        return;
                    }
                    this.fetchData();
                });
        },
        searchClient(search, loading) {
            loading(true);
            const data = {
                name: search
            };
            this.$http
                .post("master/clients/filter/search", data)
                .then(res => {
                    this.clientOptions = res.data;
                    loading(false);
                })
                .catch(() => {
                    this.searchArea(search, loading);
                });
        },
        createPick() {
            const selectedId = [];
            const warehousesId = [];
            const clientsId = [];

            let type = null;
            this.pickData.map(item => {
                warehousesId.push(item.warehouse_id);
                clientsId.push(item.client_id);
                selectedId.push(item.outbound_id);
                type = item.type;
            });

            const warehouseCount = [...new Set(warehousesId.map(id => id))];
            const clientCount = [...new Set(clientsId.map(id => id))];
            const distinctId = [...new Set(selectedId.map(id => id))];

            if (warehouseCount.length != 1) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "Different warehouses",
                    time: 5000
                });
            } else if (clientCount.length != 1) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "Different clients",
                    time: 5000
                });
            } else {
                this.isLoading = true;
                console.log("asd");
                this.$http
                    .post("pick/wavepickpartition", {
                        outbound_ids: distinctId,
                        type: type
                    })
                    .then(res => {
                        this.fetchData();
                        this.pickData = [];
                        this.showPickedData = false;
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            iconPack: "feather",
                            icon: "icon-check",
                            text: "Pick list created",
                            time: 5000,
                            click: () => {
                                this.$router.push({
                                    name: "pick-list-view",
                                    params: {
                                        id: res.data.pick_list_id
                                    }
                                });
                            }
                        });
                    })
                    .catch(error => this.handleError(error))
                    .then(() => (this.isLoading = false));
            }
        },
        filterData() {
            this.fetchData();
        },
        addPickData() {
            let error = false;
            this.pickData = [];
            this.gridApi.getSelectedRows().map(item => {
                this.pickData.map(data => {
                    if (data.id == item.details[0].id) {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            iconPack: "feather",
                            icon: "icon-x",
                            text:
                                "Reference " +
                                item.outbound_reference +
                                " already exist in wave pick planning."
                        });

                        error = true;
                    }
                });
            });

            this.gridApi.getSelectedRows().map(item => {
                item.details.map(detail => {
                    detail.index = this.pickData.length + 1;
                    detail.type = item.type;
                    detail.client_id = item.client_id;
                    detail.reference = item.outbound_reference;
                    this.pickData.push(detail);
                });
            });
        },
        createPickInit() {
            if (this.gridApi.getSelectedRows().length > 10) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "Max 20 outbound data."
                });
                return false;
            }

            this.showPickedData = true;
        },
        back() {
            this.$router.push({ name: "wave-pick-planning" });
        },
        deleteSelected() {
            let id = [];
            this.selected.map(item => {
                id.push(item.outbound_id);
                this.pickData.map((data, index) => {
                    if (data.id == item.id) {
                        this.pickData.splice(index, 1);
                    }
                });
            });

            id.map(did => {
                this.pickData.map((data, index) => {
                    if (did == data.outbound_id) {
                        this.pickData.splice(index, 1);
                    }
                });
            });

            this.pickData.map((data, index) => {
                data.index = index + 1;
            });

            this.selected = [];
        }
    },
    mounted() {
        this.fetchData();
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Outbound ID",
                field: "id",
                width: 170,
                filter: true,
                checkboxSelection: true,
                headerCheckboxSelection: true
            },
            {
                headerName: "Client ID",
                field: "client_code",
                width: 120,
                filter: true
            },
            {
                headerName: "Reference",
                field: "outbound_reference",
                filter: true,
                width: 120
            },
            {
                headerName: "Req. Del. Date",
                field: "req_del_date",
                filter: true,
                width: 120
                // pinned: 'left'
            },
            {
                headerName: "Origin",
                field: "origin",
                filter: true,
                width: 120
            },
            {
                headerName: "Destination",
                field: "destination",
                filter: true,
                width: 120
            },
            {
                headerName: "PO Reference",
                field: "po_reference",
                filter: true,
                width: 120
            },
            {
                headerName: "Status",
                field: "status",
                filter: true,
                width: 120
            }
        ];

        this.gridOptions.getRowHeight = function(params) {
            return 35;
        };
    }
};
</script>